module.exports = __webpack_public_path__ + "media/KikiGA.e475b9ef.mp3";